<script setup>
import multiselect from "vue-multiselect";
import {computed, onMounted, ref, watch} from "vue";
import {useStore} from "vue2-helpers/vuex";
import {getLogo} from "@/helpers/logo";
import {useRoute, useRouter} from "vue2-helpers/vue-router";
import trackersFoldersService from "@/services/trackers-folders.service";
import publicCollectionsService from "@/services/public-collections.service";
import {isCollinsId} from "@/constants/constants";

const store = useStore();
const route = useRoute();
const router = useRouter();

const collectionHash = route.params.hash;
const collectionInfo = ref(null);
const filter = ref({
        categories: [],
    });

const trackers = ref([]);
const selectedCategories = ref([]);

const isCollins = computed(() => {
    return collectionInfo.value && isCollinsId(collectionInfo.value.company_id);
})

watch(filter, () => {
    getTrackers();
}, {deep: true});

watch(selectedCategories, () => {
    filter.value.categories = selectedCategories.value.map(item => item.id);
});

onMounted(async () => {
    if (store.getters.isEnterprise) {
        const {data} = await trackersFoldersService.getCollectionInfo(collectionHash);
        router.push('/trackers/folder/' + data.id);
    } else if (store.getters.isEcosystem) {
        store.commit('setPageNotFound', true);
    } else {
        getCollectionInfo();
        getTrackers();
    }
})

async function getCollectionInfo() {
    const {data} = await publicCollectionsService.getCollectionInfo(collectionHash);
    collectionInfo.value = data;
}

async function getTrackers() {
    const {data} = await publicCollectionsService.getTrackersFromCollection(collectionHash, {filter: filter.value});
    trackers.value = data;
}
</script>

<template>
    <div
        v-if="collectionInfo !== null"
        class="public-collection-page"
        :class="{'public-collection-page-rtx': isCollins}"
    >
        <div class="topbar">
            <div class="topbar__inner">
                <div class="image-block image-block--lg">
                    <img :src="getLogo(collectionInfo.company_logo)" alt="img">
                </div>
                <div>
                    <h2 class="heading2">{{ collectionInfo.name }}</h2>
                </div>
                <div class="powered-by">
                    Powered by

                    <a href="" class="logo"></a>
                </div>

                <a href="#" class="public-collection-page__user"></a>
                <b-dropdown id="topbar__dropdown" right text="" class="topbar__dropdown">
                    <b-dropdown-item href="/" class="topbar__dropdown__company">My Company</b-dropdown-item>
                    <b-dropdown-item href="/enterprises" class="topbar__dropdown__enterprises">Enterprises</b-dropdown-item>
                    <b-dropdown-item href="/public-trackers" class="topbar__dropdown__apply">Apply To Challenge</b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <div class="main-inner">
            <div v-if="isCollins" class="public-collection-page-rtx__plate">
                <h3 class="heading3">About RTX</h3>

                <p>Every day, more than 185,000 employees across our company and its three businesses – Collins Aerospace, Pratt & Whitney and Raytheon – work as one to answer the biggest questions and solve the hardest problems in aerospace and defense.</p>
            </div>

            

            <div v-else>
                <h3 class="heading3">
                    <template v-if="collectionInfo.challenges_title">
                        {{collectionInfo.challenges_title}}
                    </template>

                    <template v-else>
                        Challenges
                    </template>
                </h3>
                <div v-if="collectionInfo.description.length" class="public-collection-page__description">
                    <div class="public-collection-page__description__inner">
                        <h4 class="heading4">About {{collectionInfo.name}}</h4>
                        <p>{{collectionInfo.description}}</p>
                    </div>
                </div>
            </div>

            <div v-if="collectionInfo.show_categories_filter" class="categories-section">
                <!--<label class="categories-section__label">Categories:</label>-->

                <multiselect
                    v-model="selectedCategories"
                    :multiple="true"
                    :options="collectionInfo.categories"
                    select-label=""
                    deselect-label=""
                    label="name"
                    track-by="name"
                    class="multiselect-mid multiselect-modern-slim"
                >
                </multiselect>
            </div>

            <div v-for="tracker in trackers" :key="tracker.id" class="list-challenges">
                <h5 class="heading5">{{tracker.name}}</h5>

                <div class="list-challenges__content">
                    <p v-html="tracker.description" class="line-clamp line-clamp3"></p>

                    <template v-if="tracker.applied">
                        <router-link v-if="isCollins" :to="'/public-trackers/' + tracker.id" class="btn btn-bordered">View Submission</router-link>
                        <button v-else class="btn btn-secondary btn-lg">Applied</button>
                    </template>

                    <router-link v-else :to="'/public-trackers/' + tracker.id" class="btn btn-bordered btn--apply">Apply</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
